export * from './auditList.service';
import { AuditListService } from './auditList.service';
export * from './auditList.serviceInterface';
export * from './authorization.service';
import { AuthorizationService } from './authorization.service';
export * from './authorization.serviceInterface';
export * from './authorizationPassword.service';
import { AuthorizationPasswordService } from './authorizationPassword.service';
export * from './authorizationPassword.serviceInterface';
export * from './companyUser.service';
import { CompanyUserService } from './companyUser.service';
export * from './companyUser.serviceInterface';
export * from './laboratory.service';
import { LaboratoryService } from './laboratory.service';
export * from './laboratory.serviceInterface';
export * from './norm.service';
import { NormService } from './norm.service';
export * from './norm.serviceInterface';
export * from './position.service';
import { PositionService } from './position.service';
export * from './position.serviceInterface';
export * from './role.service';
import { RoleService } from './role.service';
export * from './role.serviceInterface';
export * from './user.service';
import { UserService } from './user.service';
export * from './user.serviceInterface';
export * from './workspace.service';
import { WorkspaceService } from './workspace.service';
export * from './workspace.serviceInterface';
export * from './workspaceUser.service';
import { WorkspaceUserService } from './workspaceUser.service';
export * from './workspaceUser.serviceInterface';
export const APIS = [AuditListService, AuthorizationService, AuthorizationPasswordService, CompanyUserService, LaboratoryService, NormService, PositionService, RoleService, UserService, WorkspaceService, WorkspaceUserService];
